import type { ScreeningQuestionType } from '@/types/screeningQuestion';

export const getQuestionTypeTranslationKey = (
  questionType: ScreeningQuestionType,
): string => {
  const typeMap: Record<ScreeningQuestionType, string> = {
    TEXT: 'QUESTION_TYPE_TEXT',
    TEXT_MULTILINE: 'QUESTION_TYPE_TEXT_MULTILINE',
    EMAIL: 'QUESTION_TYPE_EMAIL',
    URL: 'QUESTION_TYPE_URL',
    NUMBER: 'QUESTION_TYPE_NUMBER',
    CURRENCY: 'QUESTION_TYPE_CURRENCY',
    PERCENTAGE: 'QUESTION_TYPE_PERCENTAGE',
    SINGLE_SELECT: 'QUESTION_TYPE_SINGLE_SELECT',
    MULTI_SELECT: 'QUESTION_TYPE_MULTI_SELECT',
    BOOLEAN: 'QUESTION_TYPE_BOOLEAN',
    DATE: 'QUESTION_TYPE_DATE',
    DATE_RANGE: 'QUESTION_TYPE_DATE_RANGE',
    DATE_OF_BIRTH: 'QUESTION_TYPE_DATE_OF_BIRTH',
    PHONE: 'QUESTION_TYPE_PHONE',
    ADDRESS: 'QUESTION_TYPE_ADDRESS',
    GENDER: 'QUESTION_TYPE_GENDER',
    NATIONALITY: 'QUESTION_TYPE_NATIONALITY',
    FILE: 'QUESTION_TYPE_FILE',
    INFORMATION: 'QUESTION_TYPE_INFORMATION',
  };

  return typeMap[questionType] || questionType;
};
